import { z } from 'zod'
import { ContentfulRichTextDocumentSchema } from './common'

export const ContentfulStickyBannerSchema = z.object({
  identifier: z.string(),
  internalName: z.string().optional(),
  message: ContentfulRichTextDocumentSchema,
  type: z.string().optional(),
  product: z.array(z.string()).optional(),
  closable: z.boolean().optional(),
})

export type ContentfulStickyBannerType = z.infer<typeof ContentfulStickyBannerSchema>
